import { render, staticRenderFns } from "./DeleteDatabaseDialog.vue?vue&type=template&id=566e8584&"
import script from "./DeleteDatabaseDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDatabaseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports